import { Heading } from '@clayui/core';
import ClayLayout from '@clayui/layout';
import React from 'react';
import SubmitButton from '../../generic-components/button/FormButton';
import { useNavigate } from 'react-router-dom';

const SuccessScreen = () => {
    const navigate = useNavigate(); // Initialize useNavigate   

    React.useEffect(() => {
        const timeout = setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 1000);
        return () => clearTimeout(timeout);
    }, []);

    return (
        <>
            <ClayLayout.ContentSection
                className="final_screen final_screen_login"
                style={{
                    minHeight: '70vh',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }}
            >
                <div className="success_icon">
                    <svg
                        width="51"
                        height="51"
                        viewBox="0 0 41 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M13.6686 33.4921L0.442383 20.2658L6.4698 14.2384L13.6686 21.4585L34.7113 0.394531L40.7387 6.42195L13.6686 33.4921Z"
                            fill="white"
                        />
                    </svg>
                </div>
                <div className="mt-4" style={{ maxWidth: '80%' }}>
                    <Heading level={1} weight="bold" fontSize={6}>
                        <span
                            className="otp-text-center"
                            style={{ color: 'white', fontSize: '24px' }}
                        >
                            Application Submitted
                        </span>
                    </Heading>
                    <Heading level={6} weight="normal" fontSize={5}>
                        <span
                            className="otp-text-center custom-font-color"
                            style={{ fontSize: '16px' }}
                        >
                            Your request has been forwarded to the partner for
                            further review. You will be contacted shortly.
                        </span>
                    </Heading>
                </div>
                <ClayLayout.Row justify="start" className="basic_detail_form">
                    <ClayLayout.Col sm={12} md={12} lg={12} xl={12}>
                        <div className="sign_button_conatiner  button-cut mt-4">
                            <SubmitButton
                                label="Close"
                                onClick={() => navigate('/')}
                            />
                        </div>
                    </ClayLayout.Col>
                </ClayLayout.Row>
            </ClayLayout.ContentSection>
        </>
    );
};

export default SuccessScreen;


